declare global {
  interface Window { __AOP__?: { supabaseUrl?: string; supabaseAnonKey?: string; apiUrl?: string } }
}

const w = typeof window !== 'undefined' ? window.__AOP__ || {} : {};

/** Cấu hình lúc chạy (config.js do Docker sinh) ưu tiên hơn cấu hình lúc build (VITE_*). */
export const config = {
  supabaseUrl: (w.supabaseUrl || import.meta.env.VITE_SUPABASE_URL || '') as string,
  supabaseAnonKey: (w.supabaseAnonKey || import.meta.env.VITE_SUPABASE_ANON_KEY || '') as string,
  apiUrl: ((w.apiUrl || import.meta.env.VITE_API_URL || '') as string).replace(/\/+$/, ''),
};

export const isConfigured = (): boolean => Boolean(config.supabaseUrl && config.supabaseAnonKey && config.apiUrl);
